/* Keep the reading frame still when any overlay removes a classic scrollbar.
 * CSS gutter handles supporting engines. Measure only the unreserved remainder
 * for custom/older scrollbar implementations; never compensate overlay scrollbars.
 */
(function initOverlayScrollbarSpace() {
  const root = document.documentElement;
  let unlockedGutter = Math.max(0, window.innerWidth - root.getBoundingClientRect().width);
  function update() {
    const locked = /hidden|clip/.test(getComputedStyle(root).overflowY) ||
      /hidden|clip/.test(getComputedStyle(document.body).overflowY);
    const reserved = Math.max(0, window.innerWidth - root.getBoundingClientRect().width);
    if (!locked) unlockedGutter = reserved;
    const compensation = locked ? Math.max(0, unlockedGutter - reserved) : 0;
    const value = compensation + 'px';
    if (root.style.getPropertyValue('--ss-scrollbar-compensation') !== value) {
      root.style.setProperty('--ss-scrollbar-compensation', value);
    }
  }
  const observer = new MutationObserver(update);
  observer.observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
  observer.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  window.addEventListener('resize', update, { passive: true });
  window.addEventListener('pageshow', update);
  update();
})();

/* Toggle .is-scrolled on the header for glassmorphism pill transition */
(function initHeaderScroll() {
  const header = document.querySelector('store-header.header');
  if (!header) return;

  const threshold = 50;
  let ticking = false;

  function update() {
    if (window.scrollY > threshold) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  update();
})();

/* ── Title + Price inline row ──
 * Wraps the title and price block-items in a flex row so
 * price sits right-aligned on the same line as the title.
 */
(function initTitlePriceRow() {
  if (document.body.classList.contains('ss-pdp')) return;
  var titleBlock = document.querySelector('.product-info .product-info__block-item[data-block-type="title"]');
  var priceBlock = document.querySelector('.product-info .product-info__block-item[data-block-type="price"]');

  if (!titleBlock || !priceBlock) return;
  if (titleBlock.parentNode !== priceBlock.parentNode) return;

  var wrapper = document.createElement('div');
  wrapper.className = 'ss-title-price-row';
  titleBlock.parentNode.insertBefore(wrapper, titleBlock);
  wrapper.appendChild(titleBlock);
  wrapper.appendChild(priceBlock);
})();

/* ── Two-button buy flow ──
 * "Buy now" (signature yellow) → native form POST to /cart/add + server redirect to /checkout
 * "Add to Cart" (outline) → AJAX add (Impact default) + cart drawer
 *
 * The primary button uses a hidden native <form> that POSTs directly to
 * Shopify's /cart/add endpoint with return_to=/checkout. This skips all
 * AJAX, all JS event chains, and lets the server handle the redirect.
 * Result: one click, one request, instant checkout page.
 */
(function initBuyButtons() {
  var availabilityObservers = new Map();
  function resetCheckoutState() {
    document.querySelectorAll('buy-buttons[data-ss-checkout-pending]').forEach(function(container) {
      delete container.dataset.ssCheckoutPending;
      var native = container.querySelector('[type="submit"]');
      container.querySelectorAll('.ss-buy-now-primary,.ss-atc-secondary').forEach(function(button) {
        button.disabled = !!(native && native.disabled);
        button.setAttribute('aria-busy', 'false');
      });
    });
  }
  window.addEventListener('pageshow', resetCheckoutState);
  function setupButtons() {
    availabilityObservers.forEach(function(observer, button) {
      if (!button.isConnected) { observer.disconnect(); availabilityObservers.delete(button); }
    });
    var purchase = document.querySelector('.product-info__variant-picker');
    if (purchase) purchase.id = 'ss-purchase';
    var buyContainers = document.querySelectorAll('.product-info__buy-buttons buy-buttons');
    buyContainers.forEach(function(container) {
      var originalBtn = container.querySelector('[type="submit"]');
      if (!originalBtn || container.dataset.ssSetup === 'true') return;

      var form = originalBtn.closest('form');
      if (!form) return;

      /* Get the variant ID input */
      var variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;

      /* Hide original submit button */
      originalBtn.style.display = 'none';

      /* Create "Buy now" — native form POST to checkout */
      var buyNowBtn = document.createElement('button');
      buyNowBtn.type = 'button';
      buyNowBtn.className = 'ss-buy-now-primary';
      /* Label and price live in their own spans: on the rebuilt product pages the button reads
       * "Buy now … $79 $99", like the buy bar (paintBuyPrices below). */
      buyNowBtn.innerHTML = '<span class="ss-buy-now__label">Buy now</span>' +
        '<span class="ss-buy-now__price" hidden><span data-ss-buy-now></span><s data-ss-buy-was hidden></s></span>';
      var buyNowLabel = buyNowBtn.querySelector('.ss-buy-now__label');
      buyNowBtn.addEventListener('click', function() {
        // The sticky bar and the phone buy bar press this button for the visitor and name themselves first.
        var via = buyNowBtn.getAttribute('data-ss-via') || 'buy_now';
        buyNowBtn.removeAttribute('data-ss-via');
        if (container.dataset.ssCheckoutPending || originalBtn.disabled || originalBtn.getAttribute('aria-busy') === 'true') return;
        if (!form.reportValidity()) return;
        // The native product form is authoritative, including an empty one-time plan.
        // Copy quantity and line-item properties too; never fall back to a stale app input.
        var checkoutForm = document.getElementById('ss-direct-checkout');
        if (!checkoutForm) {
          checkoutForm = document.createElement('form');
          checkoutForm.id = 'ss-direct-checkout';
          checkoutForm.method = 'POST'; checkoutForm.action = '/cart/add';
          checkoutForm.hidden = true; document.body.appendChild(checkoutForm);
        }
        checkoutForm.replaceChildren();
        new FormData(form).forEach(function(value, key) {
          if (typeof value !== 'string' || key === 'return_to' || (key === 'selling_plan' && !value)) return;
          var input = document.createElement('input');
          input.type = 'hidden'; input.name = key; input.value = value;
          checkoutForm.appendChild(input);
        });
        var returnInput = document.createElement('input');
        returnInput.type = 'hidden'; returnInput.name = 'return_to'; returnInput.value = '/checkout';
        checkoutForm.appendChild(returnInput);
        container.dataset.ssCheckoutPending = 'true';
        syncAvailability();
        buyNowBtn.setAttribute('aria-busy', 'true');
        // Handed off: the page leaves for checkout, so the event also waits in the outbox for the next page.
        // The short wait before the post lets it reach the pixel directly most of the time.
        // Tracking never blocks buying: a failure here still posts the form.
        try { window.ssTrack('ss_buy_click', buyParams(form, container, via), { handoff: true }); } catch (e) {}
        setTimeout(function() {
          try { HTMLFormElement.prototype.submit.call(checkoutForm); }
          catch (error) { resetCheckoutState(); throw error; }
        }, 150);
      });

      /* Create "Add to Cart" — clicks hidden original (AJAX + cart drawer) */
      var atcBtn = document.createElement('button');
      atcBtn.type = 'button';
      atcBtn.className = 'ss-atc-secondary';
      atcBtn.textContent = 'Add to Cart';
      atcBtn.addEventListener('click', function() {
        if (!originalBtn.disabled && originalBtn.getAttribute('aria-busy') !== 'true') { try { trackAdd(form, container); } catch (e) {} }
        originalBtn.style.display = '';
        originalBtn.click();
        originalBtn.style.display = 'none';
      });

      /* Insert both buttons */
      originalBtn.parentNode.insertBefore(buyNowBtn, originalBtn);
      originalBtn.parentNode.insertBefore(atcBtn, originalBtn);

      function syncAvailability() {
        var busy = originalBtn.getAttribute('aria-busy') === 'true' || container.dataset.ssCheckoutPending === 'true';
        buyNowBtn.disabled = atcBtn.disabled = originalBtn.disabled || busy;
        atcBtn.setAttribute('aria-busy', String(busy));
        var label = originalBtn.disabled ? originalBtn.textContent.trim() : 'Buy now';
        if (buyNowLabel.textContent !== label) buyNowLabel.textContent = label;
        paintBuyPrices();
      }
      syncAvailability();
      var availabilityObserver = new MutationObserver(syncAvailability);
      availabilityObserver.observe(originalBtn, {attributes: true, attributeFilter: ['disabled', 'aria-busy']});
      availabilityObservers.set(originalBtn, availabilityObserver);
      container.dataset.ssSetup = 'true';
    });
  }

  /* ── Price on the Buy now button (rebuilt product pages and landings, body.ss-pdp) ──
   * One reading for the button and the buy bar: the current price from the price block; with a
   * plan selected, the variant's one-time price struck beside it. Nothing is written unless the
   * text changed, because these nodes sit inside the observed product-info host. */
  function buyMoney(text) { return (text || '').replace(/[^$\d.,]/g, '').replace(/\.00$/, ''); }
  function buyPrice(scope) {
    scope = scope || document;
    var nowEl = scope.querySelector('.product-info__price sale-price');
    var now = buyMoney(nowEl ? nowEl.textContent : '');
    var was = '';
    // product-form-… on the PDP, featured-product-form-… on the landings (the landings missed the struck price before)
    var form = scope.querySelector('form[id*="product-form"]') || document.querySelector('form[id^="product-form"]');
    // Seal puts its input inside the form; the SS plan picker's radios sit outside it, tied by the form attribute.
    var plan = form && (form.querySelector('[name="selling_plan"]') || document.querySelector('input[name="selling_plan"][form="' + form.getAttribute('id') + '"]:checked'));
    var json = scope.querySelector('variant-picker script[data-variant]') || scope.querySelector('script[data-variant]');
    if (plan && plan.value && json) {
      try { was = buyMoney('$' + (JSON.parse(json.textContent).price / 100).toFixed(2)); } catch (e) {}
    } else {
      var cmp = scope.querySelector('.product-info__price compare-at-price');
      if (cmp) was = buyMoney(cmp.textContent);
    }
    return { now: now, was: was && was !== now ? was : '' };
  }
  window.ssBuyPrice = buyPrice;

  /* ── GA4 ss_buy_click (analytics/events.v1.json), read at the click from the form that will be sent ── */
  function buyParams(form, container, ctaId) {
    var data = new FormData(form);
    var scope = container.closest('.product-info') || document;
    var variantId = String(data.get('id') || '');
    var variant = variantId;
    var json = scope.querySelector('variant-picker script[data-variant]');
    try { var v = JSON.parse(json.textContent); if (String(v.id) === variantId && v.title) variant = v.title; } catch (e) {}
    var price = parseFloat(String(buyPrice(scope).now).replace(/[^\d.]/g, ''));
    return {
      product: container.getAttribute('data-ss-product'),
      variant: variant,
      plan: data.get('selling_plan') ? 'subscription' : 'onetime',
      cta_id: ctaId,
      price: isFinite(price) ? price : undefined
    };
  }
  // Add to Cart stays on the page, so it reports once Impact answers: confirmed = the cart took the line.
  function trackAdd(form, container) {
    var params = buyParams(form, container, 'add_to_cart');
    var done = false, timer;
    function finish(ok) {
      if (done) return;
      done = true;
      clearTimeout(timer);
      form.removeEventListener('variant:add', onAdd);
      form.removeEventListener('cart:error', onError);
      params.confirmed = ok;
      try { window.ssTrack('ss_buy_click', params); } catch (e) {}
    }
    function onAdd() { finish(true); }
    function onError() { finish(false); }
    form.addEventListener('variant:add', onAdd);
    form.addEventListener('cart:error', onError);
    timer = setTimeout(function() { finish(false); }, 8000);
  }

  function paintBuyPrices() {
    if (!document.body.classList.contains('ss-pdp')) return;
    document.querySelectorAll('.product-info__buy-buttons .ss-buy-now-primary').forEach(function(button) {
      var wrap = button.querySelector('.ss-buy-now__price');
      if (!wrap) return;
      var price = buyPrice(button.closest('.product-info') || document);
      var show = !!price.now && !button.disabled;
      var nowEl = wrap.querySelector('[data-ss-buy-now]'), wasEl = wrap.querySelector('[data-ss-buy-was]');
      if (nowEl.textContent !== price.now) nowEl.textContent = price.now;
      if (wasEl.textContent !== price.was) wasEl.textContent = price.was;
      if (wasEl.hidden !== !price.was) wasEl.hidden = !price.was;
      if (wrap.hidden !== !show) wrap.hidden = !show;
      if (button.classList.contains('has-price') !== show) button.classList.toggle('has-price', show);
    });
  }
  document.addEventListener('sealsubs:price_update', function() { setTimeout(paintBuyPrices, 60); });
  document.addEventListener('ss:plan-change', function() { setTimeout(paintBuyPrices, 0); });

  setTimeout(setupButtons, 300);
  setTimeout(setupButtons, 1000);

  /* The <product-rerender id="product-info-…"> host is stable across variant
   * changes — only its inner DOM is replaced. Observing .product-info__buy-buttons
   * directly leaves us watching a detached node after the first variant click,
   * which is why the custom buttons never reappeared. */
  var infoRerender = document.querySelector('product-rerender[id^="product-info-"]');
  if (infoRerender) {
    new MutationObserver(function() { setTimeout(function() { setupButtons(); paintBuyPrices(); }, 50); }).observe(infoRerender, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('variant:change', function() { setTimeout(function() { setupButtons(); paintBuyPrices(); }, 50); });

  /* ── Sticky bar: hijack the existing button — change text + behavior to direct checkout ── */
  function setupStickyBar() {
    var stickyBuyContainers = document.querySelectorAll('.product-quick-add buy-buttons');
    stickyBuyContainers.forEach(function(container) {
      if (container.dataset.ssStickySetup === 'true') return;

      var originalBtn = container.querySelector('[type="submit"]');
      if (!originalBtn) return;

      var form = document.querySelector('form[id^="product-form"]');
      var variantInput = form ? form.querySelector('input[name="id"]') : null;
      if (!variantInput) return;

      var textEl = originalBtn.querySelector(':scope > div, .button__content') || originalBtn;
      textEl.textContent = 'Buy now';
      originalBtn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopImmediatePropagation();
        var primary = document.querySelector('.product-info__buy-buttons .ss-buy-now-primary');
        if (primary && !primary.disabled) { primary.setAttribute('data-ss-via', 'sticky_bar'); primary.click(); }
      }, true);

      container.dataset.ssStickySetup = 'true';
    });
  }

  setTimeout(setupStickyBar, 500);
  setTimeout(setupStickyBar, 1500);

  /* Same fix as the main buy-buttons: observe the stable <product-rerender id="…-sticky-bar">
   * host instead of its replaceable .product-quick-add child. */
  var stickyRerender = document.querySelector('product-rerender[id$="-sticky-bar"]');
  if (stickyRerender) {
    new MutationObserver(function() { setTimeout(setupStickyBar, 50); }).observe(stickyRerender, { childList: true, subtree: true });
  }
  document.addEventListener('variant:change', function() { setTimeout(setupStickyBar, 50); });
})();

/* ── Click anywhere on grid image to open lightbox ── */
(function initGridImageZoom() {
  document.querySelectorAll('.product-gallery--desktop-grid .product-gallery__media[data-media-type="image"]').forEach(function(media) {
    media.addEventListener('click', function(e) {
      /* Don't double-fire if they clicked the zoom button itself */
      if (e.target.closest('button[is="product-zoom-button"]')) return;

      var zoomBtn = media.querySelector('button[is="product-zoom-button"]');
      if (zoomBtn) {
        zoomBtn.click();
      }
    });
  });
})();

/* ── Judge.me: show "Read more" only when review is truncated ──
 * Judge.me renders the read-more link on every review regardless of length.
 * We hide it by default (CSS) and only show it when the paragraph is
 * actually clamped. Clicking toggles expansion. */
(function initReviewReadMore() {
  function processReviewBody(body) {
    if (body.dataset.ssProcessed === 'true') return;
    var p = body.querySelector('p');
    if (!p) return;

    /* Check if the content is actually truncated by the line-clamp */
    if (p.scrollHeight > p.clientHeight + 1) {
      body.classList.add('is-truncated');
    }

    var btn = body.querySelector('.jdgm-rev__body-read-more');
    if (btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var expanded = body.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Show less' : 'Read more';
      });
    }

    body.dataset.ssProcessed = 'true';
  }

  function scan() {
    document.querySelectorAll('.jdgm-rev__body').forEach(processReviewBody);
  }

  /* Initial scan after Judge.me renders */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(scan, 500); });
  } else {
    setTimeout(scan, 500);
  }

  /* Re-scan when Judge.me injects more reviews (Load More) */
  var observer = new MutationObserver(function() { scan(); });
  observer.observe(document.body, { childList: true, subtree: true });

  /* Re-scan on resize (line-clamp threshold changes with width) */
  var resizeTimer = null;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      document.querySelectorAll('.jdgm-rev__body').forEach(function(body) {
        if (body.classList.contains('is-expanded')) return;
        var p = body.querySelector('p');
        if (!p) return;
        if (p.scrollHeight > p.clientHeight + 1) {
          body.classList.add('is-truncated');
        } else {
          body.classList.remove('is-truncated');
        }
      });
    }, 200);
  });
})();

(function initScrollReveal() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ss-visible');
        revealObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
  );

  document
    .querySelectorAll(
      '.ss-truth-window, .ss-problem, .ss-products-grid, .ss-how-it-works, .ss-proof-gallery, .ss-comparison, .ss-origin, .ss-faq, .ss-final-cta, .ss-newsletter'
    )
    .forEach((element) => {
      if (element.classList.contains('ss-editorial')) return;
      element.classList.add('ss-reveal');
      revealObserver.observe(element);
    });
})();

/* ── Exclusive accordions in product info ──
 * When one accordion opens inside .product-info .accordion-group,
 * close all siblings. Uses MutationObserver on the "open" attribute
 * so it works with Impact's animated AccordionDisclosure. */
(function initExclusiveAccordions() {
  document.querySelectorAll('.product-info .accordion-group, .product-info [data-group-type="accordion-group"]').forEach(function(group) {
    var accordions = group.querySelectorAll('details.accordion');
    if (accordions.length < 2) return;

    accordions.forEach(function(accordion) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.attributeName === 'open' && accordion.hasAttribute('open')) {
            accordions.forEach(function(sibling) {
              if (sibling !== accordion && sibling.hasAttribute('open')) {
                sibling.open = false;
              }
            });
          }
        });
      });
      observer.observe(accordion, { attributes: true, attributeFilter: ['open'] });
    });
  });
})();


/* Mobile CTA is now an always-visible floating pill (see .ss-mobile-cta in
 * ss-shell.css). No scroll-reveal observer needed. */

/* ── Judge.me: visually prioritize reviews with images via CSS order ──
 * We avoid programmatic sort (dispatchEvent causes Judge.me to scroll).
 * Instead, use CSS flexbox order to push reviews with images to the top. */
(function initJudgeMeImagePriority() {
  function prioritize() {
    var reviews = document.querySelectorAll('.jdgm-rev');
    if (!reviews.length) return false;

    reviews.forEach(function(rev, i) {
      var hasImage = rev.querySelector('.jdgm-rev__photos, .jdgm-rev__media, .jdgm-rev-photo, img[src*="judgeme"]');
      rev.style.order = hasImage ? '-1' : String(i);
    });

    /* Make the parent flex so order works */
    var container = reviews[0].parentElement;
    if (container) {
      container.style.display = 'flex';
      container.style.flexDirection = 'column';
    }
    return true;
  }

  /* Judge.me loads async — retry until reviews render */
  var attempts = 0;
  var interval = setInterval(function() {
    if (prioritize() || attempts > 30) clearInterval(interval);
    attempts++;
  }, 500);
})();

/* ── Judge.me: review deep link (2026-10-13) ──
 * Review request emails link to /products/<handle>?review=1#reviews.
 * #reviews scrolls to the review widget; ?review=1 also opens the write-review
 * form by clicking Judge.me's own button, so the review counts as an on-site
 * review. The widget renders async, so both wait for it; if the button never
 * appears (web reviews off in Judge.me), the visitor is still at the reviews. */
(function initReviewDeepLink() {
  var wantsForm = false;
  try { wantsForm = new URLSearchParams(window.location.search).get('review') === '1'; } catch (e) {}
  if (window.location.hash !== '#reviews' && !wantsForm) return;

  function findButton(widget) {
    var nodes = widget.querySelectorAll('.jm-action-buttons__button, .jdgm-write-rev-link');
    for (var i = 0; i < nodes.length; i++) {
      if (/write a review/i.test(nodes[i].textContent) && nodes[i].getClientRects().length) return nodes[i];
    }
    return null;
  }

  var attempts = 0;
  var scrolled = false;
  var interval = setInterval(function() {
    attempts++;
    var widget = document.getElementById('judgeme_product_reviews');
    var rendered = widget && widget.querySelector('.jm-review-widget, .jdgm-rev-widg');
    if (widget && !scrolled && (rendered || attempts > 12)) {
      var section = widget.closest('.shopify-section') || widget;
      section.style.scrollMarginTop = '96px';
      section.scrollIntoView({ block: 'start' });
      scrolled = true;
    }
    var button = widget && wantsForm ? findButton(widget) : null;
    if (button) button.click();
    if (button || (scrolled && !wantsForm) || attempts > 60) clearInterval(interval);
  }, 250);
})();

/* ── Buy bar (phones, product pages) ──
 * One pill, the same shape as the Buy now row: "Buy now" on the left, the price on the right.
 * It floats at the bottom of the screen whenever the real buy buttons are not on screen: from the
 * first screen, and again after they have scrolled away. When the page brings the real row to the
 * pill's spot, the pill sits exactly on it (same left, width, height) and fades out, so it reads as
 * the same object landing in its place. It replaces Impact's quick-add bar on phones.
 *   - before the options were seen: a tap scrolls to them (colour picker, else the plan card)
 *   - once the options were on screen: a tap is the real Buy now (same form, variant and plan)
 * Price: the current price from the price block; with a plan selected, the one-time price struck. */
(function initBuyBar() {
  var doc = document;
  if (!doc.body.classList.contains('ss-pdp')) return;
  if (!doc.querySelector('product-rerender[id$="-sticky-bar"]')) return;
  var mq = window.matchMedia('(max-width: 699px)');
  var GAP = 16;
  var bar = doc.createElement('button');
  bar.type = 'button';
  bar.className = 'ss-buybar';
  bar.setAttribute('aria-hidden', 'true');
  bar.tabIndex = -1;
  bar.innerHTML = '<span class="ss-buybar__label">Buy now</span>' +
    '<span class="ss-buybar__price"><span class="ss-buybar__now" data-ss-buybar-now></span><s class="ss-buybar__was" data-ss-buybar-was hidden></s></span>';
  doc.body.appendChild(bar);

  var seen = false, state = '', ticking = false;
  function row() { return doc.querySelector('.product-info__buy-buttons buy-buttons'); }
  function primary() { return doc.querySelector('.product-info__buy-buttons .ss-buy-now-primary'); }
  // what there is to choose before buying: the colour picker, else the plan card, else the row itself
  function options() { return doc.getElementById('ss-purchase') || doc.querySelector('.product-info .ss-plan, .product-info .sealsubs-container') || row(); }
  function headerBottom() {
    var h = doc.querySelector('.shopify-section--header');
    return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
  }
  // the price reading is the Buy now button's own (initBuyButtons above): one source for both
  function price() {
    var read = window.ssBuyPrice ? window.ssBuyPrice(doc.querySelector('.product-info') || doc) : { now: '', was: '' };
    var nowText = read.now, was = read.was;
    bar.querySelector('[data-ss-buybar-now]').textContent = nowText;
    var wasEl = bar.querySelector('[data-ss-buybar-was]');
    if (was && was !== nowText) { wasEl.textContent = was; wasEl.hidden = false; } else { wasEl.hidden = true; }
    var p = primary();
    var pl = p && p.querySelector('.ss-buy-now__label');
    bar.querySelector('.ss-buybar__label').textContent = pl && pl.textContent.trim() ? pl.textContent.trim() : 'Buy now';
    bar.disabled = !!(p && p.disabled);
    return !!nowText;
  }
  function set(next) {
    if (next === state) return;
    state = next;
    var show = next === 'before' || next === 'after';
    bar.classList.toggle('is-visible', show);
    bar.classList.toggle('is-after', next === 'after');
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    bar.tabIndex = show ? 0 : -1;
    bar.setAttribute('data-ss-buybar-state', next);
  }
  function measure() {
    ticking = false;
    var r = row(), p = primary();
    if (!mq.matches || !r || !p) { set('off'); return; }
    var box = r.getBoundingClientRect();
    if (!box.height) { set('off'); return; }
    var spot = window.innerHeight - GAP - bar.offsetHeight;
    var opts = options();
    if (!seen && opts && opts.getBoundingClientRect().top < window.innerHeight - 120) seen = true;
    if (box.top > spot) {
      bar.style.translate = '';
      set('before');
    } else if (box.bottom <= headerBottom()) {
      seen = true;
      bar.style.translate = '';
      set('after');
    } else {
      // on screen: ride on the row while the pill fades, so the two never part
      bar.style.translate = '0 ' + Math.round(box.top - spot) + 'px';
      set('docked');
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', onScroll);

  bar.addEventListener('click', function() {
    var p = primary();
    if (state === 'after' || seen) { if (p && !p.disabled) { p.setAttribute('data-ss-via', 'phone_bar'); p.click(); } return; }
    var target = options();
    if (!target) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.scrollY - headerBottom() - 20;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  });

  var refreshTimer;
  function refresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(function() { price(); measure(); }, 80); }
  doc.addEventListener('variant:change', refresh);
  doc.addEventListener('sealsubs:price_update', refresh);
  doc.addEventListener('ss:plan-change', refresh);
  var info = doc.querySelector('product-rerender[id^="product-info-"]');
  if (info) new MutationObserver(refresh).observe(info, { childList: true, subtree: true, characterData: true });
  // the buy buttons and the Seal widget arrive after load; show the pill once there is a price to show
  var tries = 0;
  (function boot() {
    if (price() && primary()) { measure(); return; }
    if (++tries < 40) setTimeout(boot, 150);
  })();
})();

/* ── GA4 ss_variant_select and ss_review_open (analytics/events.v1.json) ──
 * Impact fires variant:change on the product form once per option the visitor picks (never on load);
 * detail.variant and detail.previousVariant tell which option moved. The write-review button is Judge.me's;
 * the ?review=1 deep link (initReviewDeepLink above) clicks it from script, so isTrusted marks the source. */
(function initBuyBlockTrack() {
  document.addEventListener('variant:change', function(e) {
    var form = e.target, d = e.detail || {}, v = d.variant;
    if (!v || !v.id || !form || !form.getAttribute) return;
    var picker = document.querySelector('variant-picker[form-id="' + form.getAttribute('id') + '"]');
    var at = 0, prev = d.previousVariant;
    if (prev && prev.options && v.options) {
      for (var i = 0; i < v.options.length; i++) if (v.options[i] !== prev.options[i]) { at = i; break; }
    }
    var legend = picker ? picker.querySelectorAll('.variant-picker__option legend')[at] : null;
    window.ssTrack('ss_variant_select', {
      product: picker ? picker.getAttribute('handle') : '',
      variant: v.title,
      option: legend ? legend.textContent.replace(/:\s*$/, '') : '',
      value: v.options ? v.options[at] : ''
    });
  });
  document.addEventListener('click', function(e) {
    var button = e.target && e.target.closest && e.target.closest('.jm-action-buttons__button, .jdgm-write-rev-link');
    if (!button || !/write a review/i.test(button.textContent)) return;
    var host = document.querySelector('.product-info buy-buttons[data-ss-product]');
    window.ssTrack('ss_review_open', {
      product: host ? host.getAttribute('data-ss-product') : '',
      source: e.isTrusted ? 'widget' : 'deeplink'
    });
  });
})();
